<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Table-->
				<!--Menu Bar-->
				<div class="lock-to-top" style="background-color: #ffffff">
					<!--Buttons-->
					<div class="button-body flex">
						<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

						<!--INSERT CUSTOM BUTTONS HERE-->
						<button [disabled]="IsLoading() == true" *ngIf="IsSU() == true" class="btn btn-info" style="margin-left: 5px" (click)="onAdd()">
							Add Activation Code
						</button>
						<button [disabled]="IsLoading() == true" *ngIf="IsSU() == true" class="btn btn-info" style="margin-left: 5px" (click)="onEdit()">
							Edit Activation Code
						</button>
						<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onPrint()">Print</button>
						<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onEmail()">Email</button>
					</div>
				</div>

				<!--Table-->
				<div class="table-main-body">
					<p-table
						#mydt
						[value]="lstHSActivation"
						[loading]="loading"
						[paginator]="true"
						[(rows)]="pagerows"
						[(first)]="pagefirst"
						[showCurrentPageReport]="true"
						[resizableColumns]="false"
						sortMode="multiple"
						styleClass="p-datatable-striped"
						selectionMode="single"
						[(selection)]="SelectedHSActivation"
						dataKey="ActivationID"
						(onFilter)="onHandleFilter($event)"
						(onSort)="onHandleSort($event)"
						(onRowSelect)="onRowSelect($event)"
						(onRowUnselect)="onRowUnselect($event)"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
						[rowsPerPageOptions]="[5, 10, 25, 50]"
					>
						<!--Headers-->
						<ng-template pTemplate="header">
							<!--Filter or Select from Dropdown-->
							<tr>
								<th class="IMGCol"></th>

								<!--INSERT CUSTOM FILTERS HERE-->
								<th>
									<p-columnFilter type="text" field="ActivationCodeShort" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--AvailableCount-->
								<th>
									<!-- <p-columnFilter type="text" field="AvailableCount" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--TotalCount-->
								<th>
									<!-- <p-columnFilter type="text" field="TotalCount" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--IssueDateDesc-->
								<th>
									<!-- <p-columnFilter type="text" field="IssueDateDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--ExpireDateDesc-->
								<th>
									<!-- <p-columnFilter type="text" field="ExpireDateDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--ActiveDesc-->
								<th>
									<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterActiveDesc
												[ngModel]="value"
												[options]="lstActiveDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>
							</tr>

							<!--Column Names-->
							<tr style="height: 4rem">
								<th class="IMGCol"></th>

								<!--INSERT CUSTOM COLUMNS HERE-->
								<th class="CenterText" pSortableColumn="ActivationCodeShort">Code<p-sortIcon field="ActivationCodeShort"></p-sortIcon></th>
								<th class="CenterText" pSortableColumn="AvailableCount">Activations Left<p-sortIcon field="AvailableCount"></p-sortIcon></th>
								<th class="CenterText" pSortableColumn="TotalCount">Total Purchased<p-sortIcon field="TotalCount"></p-sortIcon></th>
								<th class="CenterText" pSortableColumn="IssueDateDesc">Issue Date<p-sortIcon field="IssueDateDesc"></p-sortIcon></th>
								<th class="CenterText" pSortableColumn="ExpireDateDesc">Expire Date<p-sortIcon field="ExpireDateDesc"></p-sortIcon></th>
								<th class="CenterText" pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
							</tr>
						</ng-template>

						<!--Data-->
						<ng-template pTemplate="body" let-HSActivation>
							<tr [pSelectableRow]="HSActivation" (dblclick)="onRowDblClick(HSActivation)">
								<td class="IMGCol">
									<div class="IMGClass">
										<img class="IMGSize" [src]="HSActivation.PhotoData" />
									</div>
								</td>

								<td *ngFor="let col of cols" style="font-weight: bold" class="CenterText">
									{{ HSActivation[col.field] }}
								</td>

								<td style="font-weight: bold" [style.color]="HSActivation.Active == 1 ? 'Black' : 'Red'" class="CenterText">
									{{ HSActivation["ActiveDesc"] }}
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>

				<!--Error Message-->
				<div class="TopMargin">
					<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
						{{ errorMessage }}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
